export default __webpack_public_path__ + "static/media/15.269c8ee2.jpg";